import { AxiosError } from 'axios';
import { useSessionContext } from '../../authentication/session';
import { defaultCallApi, useApi } from '..';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrlDefault = (path: string) => `${apiPath}${path}`;

export const useRefreshApi = (
  apiUrl: (path: string) => string = apiUrlDefault,
  errorHandler: ((res: AxiosError) => void) | null = null,
  callApi: (responseCall: any, apiCall: any) => Promise<any> = defaultCallApi,
) => {
  const { refreshToken } = useSessionContext();

  return useApi(apiUrl, errorHandler, async (responseCall, apiCall) => {
    refreshToken();
    return callApi(responseCall, apiCall);
  });
};
